import { createAsyncThunk } from '@reduxjs/toolkit';

import { formReadyForSendingSelector, selectStepsFields, defaultStepperConfigSelector } from 'entities/creditForm';
import { accountSelector } from 'entities/user/model/user.selectors';

import { sendCustomerDataThunk, type TSendCustomerDataThunkState } from 'features/SendCustomerData';

import { recalculateSteps } from './stepper';

export const updateUserDataThunk = createAsyncThunk<boolean, void, { state: TSendCustomerDataThunkState }>(
  'updateUserData/updateUserDataThunk',
  async (_, { dispatch, getState }) => {
    const user = accountSelector(getState());

    if (!user) {
      return true;
    }

    const {
      activeStep,
      stepsWithMultiStepsOrder: steps,
      lastStep,
    } = recalculateSteps(defaultStepperConfigSelector(getState()));
    const isReady = formReadyForSendingSelector(getState());

    const filledSteps = steps.slice(0, isReady ? lastStep.stepIndex : activeStep?.stepIndex).map((step) => step.formId);

    return dispatch(sendCustomerDataThunk(selectStepsFields(filledSteps)(getState()))).unwrap();
  },
);
